import Messages from '@components/App/Messages/Messages'
import { ModalContent } from '@components/ModalContent/ModalContent'
import { PreviewPage } from '@components/PreviewPage'
import { history } from '@store/store'
import { Route, Routes } from 'react-router-dom'
import { HistoryRouter } from 'redux-first-history/rr6'

import {
  Account,
  AiSitemap,
  ApiKeys,
  DashboardActivity,
  DashboardMembers,
  DashboardRoot,
  DashboardTemplates,
  Embed,
  Figma,
  Import,
  JoinSlack,
  LegacyDashboardRedirect,
  MainRoot,
  Pricing,
  PromoCrawler,
  PromoReport,
  ResetPassword,
  Signup,
  SitemapReportProjects,
  Subscription,
  SubscriptionCheckout,
  TeamSettings,
  Templates,
} from './components'
import {
  LEGACY_CREATE_TEAM,
  LEGACY_PROJECTS,
  LEGACY_TEAM,
  LEGACY_TEAM_FOLDER,
  MAIN_ROUTES,
  PREVIEW_LINK,
  ROUTE_AI_SITEMAP,
  ROUTE_AI_SITEMAP_NEW,
  ROUTE_EMBED,
  ROUTE_EXPORT_NODE,
  ROUTE_FIGMA,
  ROUTE_IMPORT,
  ROUTE_JOIN_SLACK_PATH,
  ROUTE_PAGE_ACCOUNT,
  ROUTE_PAGE_API,
  ROUTE_PAGE_DASHBOARD,
  ROUTE_PAGE_DASHBOARD_ACTIVITY,
  ROUTE_PAGE_DASHBOARD_MEMBERS,
  ROUTE_PAGE_DASHBOARD_SETTINGS,
  ROUTE_PAGE_DASHBOARD_TEMPLATES,
  ROUTE_PAGE_HOME,
  ROUTE_PAGE_SUBSCRIPTION,
  ROUTE_PAGE_SUBSCRIPTION_CHECKOUT,
  ROUTE_PASSWORD_RESET,
  ROUTE_PRICING,
  ROUTE_PROMO_CRAWLER,
  ROUTE_PROMO_REPORT,
  ROUTE_SIGNUP,
  ROUTE_TEMPLATES,
  SITEMAP_REPORT,
} from './constants'

// Порядок объявления <Route> зеркалится тестом src/tests/router/routeMatching.test.ts:
// он решает ничьи между MAIN_ROUTES-паттернами одинакового ранга
export const Router = () => (
  <HistoryRouter history={history}>
    <Routes>
      <Route path={PREVIEW_LINK} Component={PreviewPage} />
      <Route path={ROUTE_PROMO_CRAWLER} Component={PromoCrawler} />
      <Route path={ROUTE_PROMO_REPORT} Component={PromoReport} />
      <Route path={ROUTE_JOIN_SLACK_PATH} Component={JoinSlack} />
      <Route path={ROUTE_TEMPLATES} Component={Templates} />
      <Route path={ROUTE_IMPORT} Component={Import} />
      <Route path={ROUTE_PRICING} Component={Pricing} />
      <Route path={ROUTE_AI_SITEMAP} Component={AiSitemap} />
      <Route path={ROUTE_EMBED} Component={Embed} />
      <Route path={ROUTE_FIGMA} Component={Figma} />
      <Route
        path={ROUTE_PAGE_DASHBOARD_TEMPLATES}
        Component={DashboardTemplates}
      />
      <Route path={ROUTE_PAGE_DASHBOARD} Component={DashboardRoot} />
      <Route path={LEGACY_PROJECTS} Component={LegacyDashboardRedirect} />
      <Route path={LEGACY_CREATE_TEAM} Component={LegacyDashboardRedirect} />
      <Route path={LEGACY_TEAM_FOLDER} Component={LegacyDashboardRedirect} />
      <Route path={LEGACY_TEAM} Component={LegacyDashboardRedirect} />
      <Route
        path={ROUTE_PAGE_DASHBOARD_ACTIVITY}
        Component={DashboardActivity}
      />
      <Route path={ROUTE_PAGE_DASHBOARD_MEMBERS} Component={DashboardMembers} />
      <Route path={ROUTE_PAGE_DASHBOARD_SETTINGS} Component={TeamSettings} />
      <Route path={ROUTE_PAGE_ACCOUNT} Component={Account} />
      <Route path={ROUTE_PAGE_API} Component={ApiKeys} />
      <Route path={ROUTE_PAGE_SUBSCRIPTION} Component={Subscription} />
      <Route
        path={ROUTE_PAGE_SUBSCRIPTION_CHECKOUT}
        Component={SubscriptionCheckout}
      />
      <Route path={ROUTE_EXPORT_NODE} Component={ModalContent} />
      <Route path={ROUTE_PASSWORD_RESET} Component={ResetPassword} />
      <Route path={ROUTE_SIGNUP} Component={Signup} />
      {/* Все ArtBoard-руты рендерят MainRoot, чтобы переходы между ними
          (push('/{id}') после создания/генерации) не перемонтировали Main */}
      <Route path={ROUTE_AI_SITEMAP_NEW} Component={MainRoot} />
      {MAIN_ROUTES.map((path, index) => (
        <Route key={index} path={path} Component={MainRoot} />
      ))}
      <Route path={ROUTE_PAGE_HOME} Component={MainRoot} />
      <Route path={SITEMAP_REPORT} Component={SitemapReportProjects} />
    </Routes>
    <Messages />
  </HistoryRouter>
)
